import { deepComputedFrom } from 'aurelia-deep-computed';
import { autoinject, computedFrom } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { watch } from 'aurelia-watch-decorator';
import { WidgetController } from 'controls/as-widget-container';
import { HolidayMaker, initRelatedTraveler } from 'model/forms/holiday-trip';
import { LookupsService } from 'services/lookups-service';
import { WidgetBase } from 'support/base_classes/widget-base';
import { PHONE_REGEX } from 'support/settings';

@autoinject
export class HolidayMakerWidget extends WidgetBase<HolidayMaker, WidgetController> {
  private previousRelatedTravelersLength: number = null;

  constructor(private lookups: LookupsService) {
    super();
  }

  changed() {
    this.previousRelatedTravelersLength = this.model.relatedTravelers.length;
    this.bindValidation();
  }

  private bindValidation() {
    ValidationRules
      .ensureObject<HolidayMaker>().required()
      .ensure(model => model.user).displayName('Employee').required()
      .ensure(model => model.personalPhone).displayName('Personal phone').required().matches(PHONE_REGEX).withMessage('Phone number in international format is required.')
      .on(this.model);
  }

  @computedFrom('model.user')
  get userGroupLabel() {
    const labels = [this.model.user?.jobTitle, this.model.user?.mail, this.model.user?.phone].filter(l => l != null);
    return labels.length > 0 ? labels : 'Employee';
  }

  usersLookupOptions = this.lookups.getUsersLookupOptions();

  @deepComputedFrom('model.relatedTravelers')
  get shouldAutoCreateRelatedTraveler() {
    if (this.changing) return false;
    const previousLength = this.previousRelatedTravelersLength;
    const currentLength = this.previousRelatedTravelersLength = this.model.relatedTravelers.length;
    if (currentLength !== previousLength || currentLength === 0) return false;
    const lastTraveler = this.model.relatedTravelers[currentLength - 1];
    return lastTraveler.name != null || lastTraveler.relation != null;
  }

  @watch((x: HolidayMakerWidget) => x.shouldAutoCreateRelatedTraveler)
  private shouldAutoCreateRelatedTravelerChanged(shouldAutoCreate: boolean) {
    if (shouldAutoCreate && !this.controller.disabled) this.addTraveler();
  }

  addTraveler() {
    const traveler = initRelatedTraveler();
    this.model.relatedTravelers.push(traveler);
  }
}
